import React, { Component } from 'react'
import { connect } from 'react-redux'
import { ContentHeader, StaticBox, FlowTable, Modal, LinkedInput, LinkedInputGroup } from 'components/basic'
import { notify } from 'helpers'
import http from 'API/http'
import Select from 'react-select'
import Datetime from 'react-datetime'
import { default as moment } from 'moment-timezone'


class AccessOrders extends Component {
  constructor (props) {
    super(props)
    this.state = {
      orders: [],
      stateFilter: '',
      loading: true,
      order: {},
      editModal: false
    }
  }
  componentDidMount () {
    this.getOrders(this.props.id)
  }
  componentWillReceiveProps (props) {
    if (props.updated === this.props.updated) return false
    this.getOrders(props.id)
  }
  async getOrders (id) {
    this.setState({loading: true})
    var err, res
    [err, res] = await http.get('2.4/orders', {
      accessId: id
    })
    if (err) return notify.alert('', res.cause, 'error')
    this.setState({orders: res.data, loading: false})
  }
  deleteOrder (order) {
    notify.deleteConfirm('This will delete this order', async confirmed => {
      if (!confirmed) return
      var [err, res] = await http.delete('2.4/orders/' + order.orderId)
      if (err) return notify.alert('', res.cause, 'error')
      notify.alert("Order deleted")
      this.props.callback()
    })
  }
  async updateOrder (order) {
    order.requestedDateTime = moment(order.requestedDateTime).utc().format("YYYY-MM-DD[T]HH:mm:ss[Z]")
    var [err, res] = await http.put('2.4/orders/' + order.orderId, order)
    if (err) return notify.alert('', res.cause, 'error')
    notify.alert('Order Updated!')
    this.setState({editModal: false, order: {}})
    this.getOrders(this.props.id)
  }
  render () {
    return (
      <StaticBox cols={12} icon='first-order' title='Orders'>
        <FlowTable loading={this.state.loading} paginatable={5} data={this.state.orders.map(order => [
              <a className={(order.state === 'RECEIVED' ? 'table-link' : 'hidden')} onClick={() => this.setState({editModal: true, order: order}, console.log(order))}><i className='fa fa-edit' /></a>,
              this.fromOrderState(order.state),
              order.operation,
              order.service,
              moment.utc(order.requestedDateTime).format('YYYY-MM-DD HH:mm:ss'),
              <a className={(order.state === 'RECEIVED' ? 'table-link' : 'hidden')} onClick={() => this.deleteOrder(order)}><i className='fa fa-trash-o' /></a>,
            ])}>
          <tr>
            <th className='buttons' />
            <th style={{'width': '120px'}}>State</th>
            <th>Operation</th>
            <th>Service</th>
            <th>Time</th>
            <th className='buttons' />
          </tr>
        </FlowTable>
        <Modal noOverflow title={'Edit ' + this.state.order.service} isOpen={this.state.editModal} close={e => this.setState({editModal: false})} buttons={[
            { text: 'Cancel', event: e => this.setState({editModal: false, order: {}}) },
            { text: 'Update', event: e => this.updateOrder(this.state.order) }
        ]}>
          <label>Activation time</label>
          <Datetime value={moment(this.state.order.requestedDateTime).format("YYYY-MM-DD HH:mm")} onChange={date => {
            this.setState({order: {...this.state.order, requestedDateTime: date}})
          }} dateFormat={'YYYY-MM-DD'} inputProps={{placeholder: 'As soon as possible.'}} timeFormat={'HH:mm'} renderInput={props =>
            <div className='input-group'>
              <span className='input-group-addon'><i className='fa fa-fw fa-calendar' /></span>
              <input {...props} className='form-control' />
            </div>
          } />
          <LinkedInputGroup ref={(form) => { this.form = form }}>
            <div className='row'>
              <div className='col-md-12'>
                <label>Your Internal Reference</label>
                <LinkedInput validate={/.{1,}/} errorMessage='This field is required' context={this} path='order.spReference' />
              </div>
              <div className='col-md-12'>
                <label>Your subscription ID</label>
                <LinkedInput validate={/.{1,}/} errorMessage='This field is required' context={this} path='order.spSubscriptionId' />
              </div>
            </div>
          </LinkedInputGroup>
          {this.state.activating && <NoContentBox icon='circle-o-notch fa-spin' text='' />}
        </Modal>
      </StaticBox>
    )
  }
  fromOrderState(state) {
    switch (state) {
      case 'DONE_SUCCESS':
        return <span className='label orders-label label-success'><b>{state}</b></span>
        break;
      case 'RECEIVED':
        return <span className='label orders-label label-primary'><b>{state}</b></span>
        break;
      case 'IN_PROGRESS':
        return <span className='label orders-label label-warning'><b>{state}</b></span>
        break;
      case 'DONE_FAILED':
        return <span className='label orders-label label-danger'><b>{state}</b></span>
        break;
      default:
    }
  }
}
export default AccessOrders



// WEBPACK FOOTER //
// ./src/projects/flow-gui-access/components/2.4/access/AccessOrders.js